<template>
  <!-- Trip Details Section -->
  <div class="mb-6">
    <h3 class="text-lg font-semibold mb-4">Kelionės informacija:</h3>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div class="card bg-base-200">
        <div class="card-body">
          <h3 class="card-title text-lg">
            Bendra informacija
            <span
              v-if="travelData.status"
              :class="['badge', statusConfig[travelData.status].class]"
            >
              {{ statusConfig[travelData.status].text }}
            </span>
          </h3>
          <p>Data: {{ travelData.date }}</p>
          <p>Organizuoja: {{ travelData.organization?.info }}</p>
          <p v-if="travelData.trips_count">
            Pavėžėjimų skaičius: {{ travelData.trips_count }}
          </p>
        </div>
      </div>

      <div class="card bg-base-200">
        <div class="card-body">
          <h3 class="card-title text-lg">
            Automobilis ir vairuotojas
            <slot name="vehicle-driver-actions" />
          </h3>
          <p>Automobilis: {{ travelData.vehicle.info }}</p>
          <p>Vairuotojas: {{ travelData.driver.info }}</p>
          <p>Priklauso: {{ travelData.vehicle?.organization }}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="mb-6">
    <h3 class="text-lg font-semibold">Kelionės laikai:</h3>
    <ul class="timeline timeline-vertical">
      <li v-for="(waypoint, index) in travelData.waypoints" :key="index">
        <hr v-if="index !== 0" />
        <div class="timeline-middle">
          <div :class="['rounded-full w-4 h-4', getDotColor(waypoint)]"></div>
        </div>
        <div class="timeline-end">
          <div class="font-semibold pt-8">{{ waypoint.address }}</div>
          <div v-if="waypoint.trip_id && waypoint.trip_id !== 9999">
            Pavėžėjimo nr.: {{ waypoint.trip_id }}
          </div>
          <div>Numatytas laikas: {{ waypoint.time }}</div>
          <div v-if="waypoint.time_fact">
            Faktinis laikas: {{ waypoint.time_fact }}
          </div>
          <div v-if="waypoint.timePlanning" class="text-base">
            Planuojamas laikas: {{ waypoint.timePlanning }}
          </div>
          <div
            v-if="
              waypoint.timeValid === false &&
              index !== 0 &&
              index !== travelData.waypoints.length - 1
            "
            class="badge badge-error mr-1"
          >
            Netinka laikas
          </div>
          <div v-if="waypoint.isInRestriction" class="badge badge-warning mr-1">
            Patenka į buferį
          </div>
          <div
            v-if="['start', 'finish', 'planning'].includes(waypoint.type)"
            class="badge badge-neutral badge-outline mr-1"
          >
            {{ getLabel(waypoint.type) }}
          </div>
        </div>
        <hr v-if="index !== travelData.waypoints.length - 1" />
      </li>
    </ul>
  </div>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  travelData: {
    type: Object,
    required: true,
  },
});

const statusConfig = {
  travelStatus1: {
    text: "Planuojama",
    class: "badge-info",
  },
  travelStatus2: {
    text: "Vykdoma",
    class: "badge-warning",
  },
  travelStatus3: {
    text: "Pasibaigusi",
    class: "badge-success",
  },
};

const getDotColor = (waypoint) => {
  if (waypoint.type === "start" || waypoint.type === "finish")
    return "bg-neutral";
  if (waypoint.timeValid === false) return "bg-error";
  if (waypoint.time_fact) return "bg-success";
  return "bg-error";
};

const getLabel = (type) => {
  switch (type) {
    case "start":
      return "Pradžia";
    case "finish":
      return "Pabaiga";
    case "planning":
      return "Naujas pavėžėjimas";
    default:
      return "";
  }
};
</script>
